import { useEffect, useState } from 'react'
import { setImportPromise } from '../../utils/helpers/import'

export function useLoadElfController({
  beforeInit,
  afterInit,
  onLoadPromiseInit,
  onProgress,
  getLibsPromise = Promise.resolve(),
  getWrapperPromise = Promise.resolve({ default: null }),
} = {}) {
  const [isReady, setIsReady] = useState(false)

  useEffect(() => {
    const data = {}

    let isUnmounted = false

    const promise = (async () => {
      try {
        await getLibsPromise()

        if (isUnmounted) return data

        const { default: WrapperClass } = await getWrapperPromise()
        const wrapper = WrapperClass.instance

        data.wrapper = wrapper

        onProgress &&
          wrapper.eventBus.addEventListener('scene-controller:loading-progress', onProgress)

        if (isUnmounted) return data

        await beforeInit?.(data)

        await wrapper?.init()

        await afterInit?.(data)

        setIsReady(true)

        return data
      } catch (err) {
        console.log('Ошибка при загрузке игры', err)
        return data
      }
    })()

    data.promise = promise
    setImportPromise(promise)

    onLoadPromiseInit?.(data)

    return () => {
      isUnmounted = true
    }
  }, [])

  return { isGameInitialized: isReady }
}
